import { AnalyticsBrowser } from '@segment/analytics-next';
import { createContext, ReactNode, useMemo } from 'react';

const SEGMENT_WRITE_KEY = import.meta.env.VITE_SEGMENT_WRITE_KEY;

type AnalyticsContextValue = {
  analytics: AnalyticsBrowser;
};

const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);

type AnalyticsContextProps = {
  children: ReactNode;
};

export const AnalyticsProvider = ({ children }: AnalyticsContextProps) => {
  const analytics = useMemo(() => AnalyticsBrowser.load({ writeKey: SEGMENT_WRITE_KEY }), []);

  return <AnalyticsContext.Provider value={{ analytics }}>{children}</AnalyticsContext.Provider>;
};

AnalyticsProvider.AnalyticsContext = AnalyticsContext;
